/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningTriangleIcon20Solid = forwardRef('WarningTriangleIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.909 2.32c.955-1.565 3.227-1.565 4.182 0l6.535 10.701c.997 1.633-.178 3.727-2.09 3.727H3.464c-1.913 0-3.088-2.094-2.091-3.727L7.909 2.32Zm3.216 11.055a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0ZM11 6a1 1 0 1 0-2 0v3.75a1 1 0 0 0 2 0V6Z" })));
});
